const actions = {
    FORGOT_PASSWORD : 'FORGOT_PASSWORD',
    UPDATE_STATUS : 'UPDATE_STATUS',
    CHANGE_PASSWORD : 'CHANGE_PASSWORD',
    CHANGE_PASSWORD_STATUS : 'CHANGE_PASSWORD_STATUS',
};

export default actions;